// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"341":"742aa4ad","727":"486cbe3a"}[chunkId] + ".chunk.js");